export class Client {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    address: string;
    phone: string;
    fullname?: string = '';

    constructor(client) {
        if (client.id) { this.id = client.id; }
        this.firstName = client.firstName;
        this.lastName = client.lastName;
        this.email = client.email;
        this.address = client.address;
        this.phone = client.phone;
        this.fullname = [client.firstName, client.lastName].map(part => part?.trim()).filter(Boolean).join(' ');
    }
}
